// extracted by mini-css-extract-plugin
export default {"cls1":"StickyWorkCardHeader-cls1_Ki5","cls2":"StickyWorkCardHeader-cls2_Cxi StickyWorkCardHeader-cls1_Ki5"};